import { render, staticRenderFns } from "./GameStore.vue?vue&type=template&id=e47c5122"
import script from "./GameStore.vue?vue&type=script&lang=js"
export * from "./GameStore.vue?vue&type=script&lang=js"
import style0 from "./GameStore.vue?vue&type=style&index=0&id=e47c5122&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports